export const isNonOccupyingReservation = (reservation) => {
  const cancellationFlag = String(reservation?.is_cancelled ?? "")
    .trim()
    .toLowerCase();
  const status = String(reservation?.status || reservation?.reservation_status || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");

  return (
    cancellationFlag === "true" ||
    cancellationFlag === "1" ||
    ["cancelled", "canceled", "noshow"].includes(status)
  );
};
